import { render } from "./DashboardsMapBlock.vue?vue&type=template&id=c513b236&scoped=true&ts=true"
import script from "./DashboardsMapBlock.vue?vue&type=script&lang=ts"
export * from "./DashboardsMapBlock.vue?vue&type=script&lang=ts"

import "./DashboardsMapBlock.vue?vue&type=style&index=0&id=c513b236&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c513b236"]])

export default __exports__